import {
  GetCollaboratorCmSheetDevelopmentCommentsResponse,
  UpdateCollaboratorCmSheetDevelopmentCommentsRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetDevelopmentCommentsService = {
  async get(
    cmSheetId: number,
  ): Promise<GetCollaboratorCmSheetDevelopmentCommentsResponse> {
    const response =
      await httpClient.get<GetCollaboratorCmSheetDevelopmentCommentsResponse>(
        `v1/cm-sheets/${cmSheetId}/development-comments`,
      );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCollaboratorCmSheetDevelopmentCommentsRequest,
  ): Promise<void> {
    await httpClient.put(
      `v1/cm-sheets/${cmSheetId}/development-comments`,
      body,
    );
  },
};

export default CmSheetDevelopmentCommentsService;
